<script setup>
import { ref } from 'vue';
import { useKanbanStore } from '@/stores/kanban';
import ModalOverlay from './ModalOverlay.vue';

const kanbanStore = useKanbanStore();

const viewDocument = ref(null);
const id = ref(0);
const date = ref('');
const isSubmitting = ref(false);

const openModalCopy = (value) => {
  id.value = value;
  date.value = '';
  if (viewDocument.value) viewDocument.value.openModal();
};

const copy = async () => {
  if (isSubmitting.value || !id.value) return;

  isSubmitting.value = true;

  try {
    await kanbanStore.duplicateTask(id.value, { date: date.value });

    if (viewDocument.value) viewDocument.value.closeModal();

    id.value = 0;
    date.value = '';
  } catch (error) {
    console.error('Erro ao duplicar tarefa:', error);
  } finally {
    isSubmitting.value = false;
  }
};

defineExpose({
  openModalCopy
});
</script>

<template>
  <div>
    <ModalOverlay ref="viewDocument">
      <template #header>
        <div class="d-flex justify-content-between align-items-center w-100">
          <h5 class="m-0 font-docs font-weight-bold" style="font-size: 18px; color: #212529;">
            Copiar tarefa
          </h5>
          <button
            id="close"
            type="button"
            class="close"
            @click="viewDocument.closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <template #body>
        <div class="font-docs">
          <label class="label-custom mb-2">Informe a data para a qual a tarefa será copiada:</label>
          <input type="date" class="input-custom" v-model="date">
        </div>
      </template>

      <template #footer>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-action font-docs" @click="viewDocument.closeModal()">
            Cancelar
          </button>
          <button type="button" class="btn btn-solid-action font-docs" @click="copy" :disabled="isSubmitting">
            <span v-if="isSubmitting" class="spinner-border spinner-border-sm mr-2"></span>
            {{ isSubmitting ? 'Copiando...' : 'Continuar' }}
          </button>
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<style scoped>
.font-docs {
  font-family: inherit;
}

.label-custom {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  display: block;
}

.input-custom {
  width: 100%;
  height: 40px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  outline: none;
}

.btn-outline-action {
  color: #F1860B;
  border: 1px solid #F1860B;
  background: transparent;
  font-weight: 600;
  padding: 6px 18px;
  border-radius: 6px;
}

.btn-solid-action {
  background-color: #F1860B;
  color: #ffffff;
  border: 1px solid #F1860B;
  font-weight: 600;
  padding: 6px 20px;
  border-radius: 6px;
}
</style>